import { render, staticRenderFns } from "./MbFitText.vue?vue&type=template&id=1296d0f6"
import script from "./MbFitText.vue?vue&type=script&lang=js"
export * from "./MbFitText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports